module.exports = __webpack_public_path__ + "2d27993064a890abf252036cf65d3319.svg";